import isStrictObject from "../../common-utils/object/isStrictObject.util.js";
export const objectLengthUtil = (obj) => isStrictObject(obj) ? Object.keys(obj).length : 0;
export default objectLengthUtil;
